import { useSelector } from 'react-redux';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';

import { changeVehicleSelectors } from '../../store';
import { MAX_SCENARIO_COUNT } from '../../constants';

/**
 * Whether a new deal scenario can be offered at all, and whether the deal already holds as many as it can.
 *
 * The footer, the result rows, the alternative vehicle options card and the build-vehicle card all read this, so no two
 * surfaces can disagree about either — which is the reason they derive them from these signals rather than each taking
 * a prop of its own. Vehicle validity is deliberately not here: each surface already validates the vehicle it is
 * showing, and a scenario is only offered for a vehicle the dealer could apply, so each combines its own validity with
 * the limit below.
 */
export const useAddNewScenarioAvailability = () => {
    // Only whether the host can clone a scope, which today is Manager View alone. Multi-scenario itself carries no
    // toggle or dealer setting — MultiScenarioActions renders on scopeId && !isFnIDealMode — so there is nothing
    // further to ask. The dealer's AI settings decide whether a surface exists, not whether it may offer a scenario.
    const canAddNewScenario = useSelector(changeVehicleSelectors.canCreateScenario);

    // scopedStateSelectors read state.__scopeMap, which only the dash (MV) app has — the footer and the rows also
    // render in open-deal, choose-vehicle and sales-checkin, where getInitializedScopesOrder would throw. The host gate
    // above keeps the read out of those, and the count only matters for the Manager View button anyway.
    const scopesCount = useSelector((state: any) =>
        canAddNewScenario ? scopedStateSelectors.getInitializedScopesOrder(state).length : 0
    );
    const isScenarioLimitReached = scopesCount >= MAX_SCENARIO_COUNT;

    return { canAddNewScenario, isScenarioLimitReached };
};
